import React from 'react';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import { IProps } from './types';

class CookieConsent extends React.Component<IProps> {
  state = {
    accept: JSON.parse(storageService.getItem(storageKeys.AcceptCookieConsent))
  };

  handleAccept = () => {
    this.setState({ accept: true });
    storageService.setItem(storageKeys.AcceptCookieConsent, JSON.stringify(true));
  };

  render () {
    return (!this.state.accept && this.props.content) ? (
      <div className="cookie-consent">
        <div className="cookie-consent__container">
          <p>{this.props.content}</p>
          <button type="button" onClick={this.handleAccept}>好，我知道了！</button>
        </div>
      </div>
    ) : null;
  }
};

export default CookieConsent;
